import React, { useState, useEffect } from 'react';
import {getUserIdFromStorage} from "../../api/auth.sso";
import {apiRequest} from "../../api";
import {getUserData} from "../../api/userData";

const FilterModal = ({ isOpen, onClose, onApplyFilters, onResetFilters, currentFilters, flowTypes }) => {
  const [filters, setFilters] = useState({
    createdAt: ['', ''],
    flow: '',
    label: '',
    region: ''
  });
  // Состояние для хранения данных фильтров
  const [regions, setRegions] = useState([]);
  const [filteredFlowTypes, setFilteredFlowTypes] = useState([]);

  // Загрузка данных для фильтров при монтировании компонента
  useEffect(() => {
    let isMounted = true;
    const loadData = async () => {
      try {
        const userID = getUserIdFromStorage();

        // Проверяем, что компонент все еще смонтирован
        if (!isMounted) return;

        // Сначала загружаем лиды с примененными фильтрами
        const loadedRegionsResponse = await apiRequest('regions', 'GET');
        const loadedRegions = loadedRegionsResponse.data || [];
        // Проверяем, что компонент все еще смонтирован
        if (!isMounted) return;

        const flowsData = await getUserData(userID)
        const userFlows = flowsData?.flows;
        // Проверяем, что компонент все еще смонтирован
        if (!isMounted) return;

        // Фильтруем flowTypes по id которые есть в userFlows (flow_guide_id)
        const loadedFlowTypesResponse = await apiRequest('flow-guides', 'GET');
        const loadedFlowTypes = loadedFlowTypesResponse.data || [];
        let loadedFilteredFlowTypes = loadedFlowTypes;
        if (userFlows && userFlows.length > 0) {
          const userFlowIds = userFlows.map(flow => flow.flow_guide_id);
          loadedFilteredFlowTypes = loadedFlowTypes.filter(ft => userFlowIds.includes(ft.id));
        }
        // Сортируем регионы по названию в алфавитном порядке
        loadedRegions.sort((a, b) => a.region.localeCompare(b.region));
        // Проверяем, что компонент все еще смонтирован
        if (isMounted) {
          setFilteredFlowTypes(loadedFilteredFlowTypes);
          setRegions(loadedRegions);
        }
      } catch (error) {
        console.error('Ошибка при загрузке данных для фильтров:', error);
      }
    };

    loadData();
    return () => {
      isMounted = false;
    };
  }, [flowTypes]);

  // Инициализация фильтров при открытии модального окна
  useEffect(() => {
    if (isOpen) {
      setFilters(currentFilters || {
        createdAt: ['', ''],
        flow: '',
        label: '',
        region: ''
      });
    }
  }, [isOpen, currentFilters]);

  const handleApply = () => {
    onApplyFilters(filters);
    onClose();
  };

  const handleReset = () => {
    setFilters({
      createdAt: ['', ''],
      flow: '',
      label: '',
      region: ''
    });
    onResetFilters();
  };

  // Преобразуем ID фильтров обратно в строки для отображения в селектах
  const displayFilters = {
    ...filters,
    flow: filters.flow ? filters.flow.toString() : '',
    label: filters.label ? filters.label.toString() : '',
    region: filters.region ? filters.region.toString() : ''
  };

  if (!isOpen) return null;

  return (
    <div
      className="modal-overlay"
      onClick={onClose}
    >
      <div
        className="modal small-3 bottom-right open"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="modal-header">
          <h3>Фильтр «Мои идентификации»</h3>
        </div>
        <div className="modal-body">
          <div className="d-flex gap-2">
            <div className="filter-group flex-grow-1">
              <label>Дата от</label>
              <input
                type="date"
                value={filters.createdAt[0] || ''}
                onChange={(e) => {
                  const newDateRange = [...filters.createdAt];
                  newDateRange[0] = e.target.value;
                  setFilters({...filters, createdAt: newDateRange});
                }}
                className="filter-input w-100"
              />
            </div>
            <div className="filter-group flex-grow-1">
              <label>Дата по</label>
              <input
                type="date"
                value={filters.createdAt[1] || ''}
                onChange={(e) => {
                  const newDateRange = [...filters.createdAt];
                  newDateRange[1] = e.target.value;
                  setFilters({...filters, createdAt: newDateRange});
                }}
                className="filter-input w-100"
              />
            </div>
          </div>

          <div className="filter-group mt-3">
            <label>Поток</label>
            <select
              value={displayFilters.flow}
              onChange={(e) => setFilters({...filters, flow: e.target.value})}
              className="filter-input w-100"
            >
              <option value="">Все потоки</option>
              {filteredFlowTypes.map(flowType => (
                <option key={flowType.id} value={flowType.id}>{flowType.flow_name}</option>
              ))}
            </select>
          </div>

          <div className="filter-group mt-3">
            <label>UTM_SOURCE</label>
            <input
              type="text"
              value={displayFilters.label}
              onChange={(e) => setFilters({...filters, label: e.target.value})}
              className="filter-input w-100"
              placeholder="Введите UTM_SOURCE..."
            />
          </div>

          <div className="filter-group mt-3">
            <label>Регион</label>
            <select
              value={displayFilters.region}
              onChange={(e) => setFilters({...filters, region: e.target.value})}
              className="filter-input w-100"
            >
              <option value="">Все регионы</option>
              {regions.map(region => (
                <option key={region.id} value={region.region}>{region.region}</option>
              ))}
            </select>
          </div>
        </div>
        <div className="modal-footer">
          <button
            className="btn btn-reset"
            onClick={handleReset}
          >
            Сбросить
          </button>
          <button
            className="btn btn-primary-filled"
            onClick={handleApply}
          >
            Отфильтровать
          </button>
        </div>
      </div>
    </div>
  );
};

export default FilterModal;
